module.exports = __webpack_public_path__ + "static/media/haimian-dahuajieyouhu.3c1250d2.png";